import { Breadcrumbs, Link, Typography } from '@mui/material';
import { matchPath, useLocation } from 'react-router-dom';
import { PAGE, Path } from '../../../constants/page';

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function NavBreadcrumbs(props: Props) {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  // パンくず用にPATH定義を配列で持つ
  const pages: Path[] = Object.values(PAGE);

  // パスを段階的に構築してマッチさせる
  const breadcrumbs = pathnames.map((_, index) => {
    const currentPath = '/' + pathnames.slice(0, index + 1).join('/');

    // `:id` などの動的ルートも考慮してマッチ
    const matchedPage = pages.find((page) => matchPath({ path: page.PATH, end: true }, currentPath));

    return {
      name: matchedPage?.NAME ?? currentPath,
      path: currentPath,
      isLast: index === pathnames.length - 1,
    };
  });

  // ホームは常に先頭
  const topPage = pages.find((p) => p.PATH === '/');

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {topPage && (
        <Link underline="hover" color="inherit" href={topPage.PATH}>
          {topPage.NAME}
        </Link>
      )}
      {breadcrumbs.map(({ name, path, isLast }) =>
        isLast ? (
          <Typography color="text.primary" key={path}>
            {name}
          </Typography>
        ) : (
          <Link underline="hover" color="inherit" href={path} key={path}>
            {name}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
}
